import React from 'react';
import Fnav from '../Step1/Step12/components/Fnav/Fnav';
import MarketingStepsShell from './MarketingStepsShell';
import { buildDemoStep1State } from './marketingStepDemoData';
import '../Step1/Question/Question.css';
import '../Step1/Step12/Step12.css';
import '../Step1/Step12/components/Fnav/Fnav.css';
import '../Common/ListFs/ListFs.css';
import './MarketingAssets.css';

/** V1 Step 1 — F-nav sidebar + assessment question (production layout). */
const MarketingStep1Preview = () => {
    const demoState = buildDemoStep1State();
    const currentQ =
        demoState.Fs[demoState.index].questions[demoState.currentQuestion];
    const fColor = demoState.Fs[demoState.index].color;

    return (
        <MarketingStepsShell activeStep={0} className="marketing-step1">
            <section className="step1slice__container">
                <div className="s12__container">
                    <div className="fnav__container">
                        <Fnav
                            state={demoState}
                            handleChange={() => {}}
                            handleChangeState={() => {}}
                        />
                    </div>
                    <div className="fQuestions__container">
                        <div className="questionsPie__container">
                            <div
                                className="question__container"
                                style={{
                                    '--f-color': fColor,
                                    '--q-progress': `${
                                        ((demoState.currentQuestion + 1) / 10) *
                                        100
                                    }%`,
                                    '--val': currentQ.score || 1,
                                }}
                            >
                                <div className="questionNumber__container">
                                    <h5
                                        className="heading-6 questionCounter"
                                        style={{ color: fColor }}
                                    >
                                        QUESTION{' '}
                                        {demoState.currentQuestion + 1}/10
                                    </h5>
                                    <button
                                        type="button"
                                        className="btnSavePartial"
                                    >
                                        SAVE AND CONTINUE LATER
                                    </button>
                                </div>
                                <div
                                    className="questionData__containerSwipeable"
                                    style={{ height: '70%' }}
                                >
                                    <div className="questionData__container">
                                        <div className="questionData__texts">
                                            <h2>{currentQ.title}</h2>
                                            <p>{currentQ.text}</p>
                                        </div>
                                        <div className="line__container">
                                            <input
                                                type="range"
                                                min="1"
                                                max="10"
                                                readOnly
                                                className="rangeInput"
                                                value={currentQ.score || 1}
                                                style={{
                                                    background: '#78CCF6',
                                                    '--val':
                                                        currentQ.score || 1,
                                                    '--f-color': fColor,
                                                }}
                                                list="tickmarks"
                                            />
                                            <div id="tickmarks">
                                                {[
                                                    1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                    10,
                                                ].map((n) => (
                                                    <p
                                                        key={n}
                                                        className="tickmarks__numbers rangeNum"
                                                        style={{
                                                            color:
                                                                n ===
                                                                currentQ.score
                                                                    ? fColor
                                                                    : undefined,
                                                            opacity:
                                                                n ===
                                                                currentQ.score
                                                                    ? 1
                                                                    : 0.6,
                                                        }}
                                                    >
                                                        {n}
                                                    </p>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="qbuttons__container">
                                    <div className="previousButton__container">
                                        <button
                                            type="button"
                                            className="botons btnPrevious"
                                        >
                                            <h6>&lt; PREVIOUS</h6>
                                        </button>
                                    </div>
                                    <div className="nextButton__container">
                                        <button
                                            type="button"
                                            className="botons btnNext"
                                        >
                                            <h6>NEXT &gt;</h6>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </MarketingStepsShell>
    );
};

export default MarketingStep1Preview;
